import {
  BaseTable,
  Input,
  Loading,
  PaginationData,
  TableHeader,
  TableHeaderSort,
  TableNumber
} from "components"
import moment from "moment"
import React, { Fragment } from "react"
import { ReactBarcode } from "react-jsbarcode"
import { PaginationState } from "types"
import { convertNumber } from "utils"
import { useList } from "../utils"
import { Delete, Update } from "./ActionSection"
import { PicturesSection } from "./PicturesSection"

type TableSectionProps = {
  list: ReturnType<typeof useList>
  pagination: PaginationState
  setPagination: React.Dispatch<React.SetStateAction<PaginationState>>
  onDebounce: (e: any) => void
  handleSort: (item: string, sortType: string) => void
}

export function TableSection({
  list,
  pagination,
  setPagination,
  onDebounce,
  handleSort
}: TableSectionProps) {
  const header: any[] = [
    { title: "OPENING DATE", sort: true },
    { title: "BARCODE", sort: true },
    { title: "ITEM NAME", sort: true },
    { title: "PICTURES", sort: false },
    { title: "STOCK", sort: true },
    { title: "UNIT", sort: true },
    { title: "AVERAGE PRICE UNIT", sort: true },
    { title: "LOCATION", sort: true }
  ]

  return (
    <Fragment>
      <div className="flex">
        <div className="mb-3">
          <Input
            label="SEARCH"
            className="md:max-w-[300px] w-full"
            placeholder="Search..."
            onChange={onDebounce}
          />
        </div>
      </div>
      <div className="overflow-x-auto">
        <BaseTable className="border-collapse">
          <TableHeader>
            <tr>
              <th>NO</th>
              <TableHeaderSort
                title={header}
                onSort={(item, sortType) => handleSort(item, sortType)}
              />
              <th>ACTION</th>
            </tr>
          </TableHeader>
          <tbody>
            {list.isLoading || list.data?.payload?.length === 0 ? (
              <tr>
                <td colSpan={10} className="text-center">
                  <Loading
                    loading={list.isLoading}
                    errorText="No data available"
                  />
                </td>
              </tr>
            ) : (
              list.data?.payload?.map((item: any, key) => (
                <tr key={key}>
                  <td>
                    {TableNumber({
                      dataLength: list.data?.pagination_data?.size,
                      pageCurrent: pagination.page,
                      index: key,
                      limit: pagination?.limit,
                      totalData: pagination.total
                    })}
                  </td>
                  <td>{moment(item.transaction_date).format("DD/MM/YYYY")}</td>
                  <td>
                    <div className="w-10px">
                      <ReactBarcode
                        options={{
                          width: 0.5,
                          fontSize: 11,
                          height: 23
                        }}
                        value={`${item.product_barcode}`}
                      />
                    </div>
                  </td>
                  <td>{item.product_name}</td>
                  <td>
                    <div className="w-[400px] lg:w-[200px]">
                      <PicturesSection
                        dataPicture={item?.picture}
                        items={1}
                        className="h-[100px] w-full"
                      />
                    </div>
                  </td>
                  <td>{convertNumber(Number(item.soh)).intoNormalAmount}</td>
                  <td>{item.unit_name}</td>
                  <td className="text-right">
                    {item.av_price_unit
                      ? convertNumber(Number(item.av_price_unit)).intoCurrency
                      : "0"}
                  </td>
                  <td>{item.location_name}</td>
                  <td>
                    <div className="join flex justify-center">

                      {item.approve_status !== 4 && (
                        <Fragment>
                          <Update id={item.opening_stock_id} />
                          <Delete
                            id={item.opening_stock_id}
                            refetch={list.refetch}
                          />
                        </Fragment>
                      )}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </BaseTable>
      </div>
      <div className="mt-5">
        <PaginationData
          data={list.data}
          pagination={pagination}
          setPagination={setPagination}
        />
      </div>
    </Fragment>
  )
}
